import logo from '../../img/logo.png';
import Qr from '../../componentes/QR';

const AccesoQr = () => {
    return (
        <>

            <div className="min-h-full">
                <div className="bg-black pb-32">
                    <header className="py-5">
                        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                            <img
                                src={logo}
                                alt="Encuesta Parque Monchis"
                                className="w-80 h-23 mx-auto"
                            />
                        </div>
                    </header>
                </div>
            </div>

            <main className="-mt-32">
                <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                    <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6  max-w-full overflow-hidden min-h-lvh">
                        <h2 className="text-3xl font-bold text-center mb-6 mt-4">QR Encuestas</h2>
                         
                        <Qr datos={"https://app.parquemonchis.com/encuesta/?folio=nueva"}/>
                    </div>
                </div>
            </main>
        </>
    );
};

export default AccesoQr;
